export const FIREBASE_APIKEY = process.env.REACT_APP_FIREBASE_APIKEY;
export const FIREBASE_AUTHDOMAIN = process.env.REACT_APP_FIREBASE_AUTHDOMAIN;
export const FIREBASE_PROJECTID = process.env.REACT_APP_FIREBASE_PROJECTID;
export const FIREBASE_STORAGEBUCKET =
  process.env.REACT_APP_FIREBASE_STORAGEBUCKET;
export const FIREBASE_MESSAGINGSENDERID =
  process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID;
export const FIREBASE_APPID = process.env.REACT_APP_FIREBASE_APPID;
export const WARP_DESCRIPTION =
  "Warp is the intelligent terminal with AI and your dev team's knowledge built-in.";
export const WARP_TEAMS_DESCRIPTION =
  "Warp combines AI and your dev team's knowledge in one fast, intuitive terminal. Ask AI for help, type like an IDE, and collaborate with your team.";

export const TURBO_PLAN_MONTHLY_COST_PER_SEAT_PER_MONTH_BASE_PRICING_TIER = 50;
export const TURBO_PLAN_MONTHLY_COST_PER_SEAT_PER_MONTH_GRADUATED_PRICING_TIER = 35;
export const TURBO_PLAN_YEARLY_COST_PER_SEAT_PER_MONTH_BASE_PRICING_TIER = 40;
export const TURBO_PLAN_YEARLY_COST_PER_SEAT_PER_MONTH_GRADUATED_PRICING_TIER = 30;
export const TURBO_PLAN_YEARLY_DISCOUNT_PERCENTAGE = 20;
export const TURBO_PLAN_YEARLY_DISCOUNT_PERCENTAGE_GRADUATED_PRICING_TIER = 14;
export const TURBO_PLAN_GRADUATED_PRICING_THRESHOLD_SEATS = 2;
export const TEAM_PLAN_MONTHLY_COST_PER_SEAT_PER_MONTH = 25;
export const TEAM_PLAN_YEARLY_COST_PER_SEAT_PER_MONTH = 22;
export const TEAM_PLAN_YEARLY_DISCOUNT_PERCENTAGE = 12;
export const PRO_PLAN_MONTHLY_COST_PER_SEAT_PER_MONTH = 18;
export const PRO_PLAN_YEARLY_COST_PER_SEAT_PER_MONTH = 15;
export const PRO_PLAN_YEARLY_DISCOUNT_PERCENTAGE = 17;
export const PRO_PLAN_AI_REQUEST_LIMIT = 2500;
export const TEAM_PLAN_AI_REQUEST_LIMIT = Infinity;
export const TURBO_PLAN_AI_REQUEST_LIMIT = 10000;
export const PRO_PLAN_CODEBASES_INDEXED = 40;
export const TURBO_PLAN_CODEBASES_INDEXED = 40;
export const PRO_PLAN_CODEBASE_CONTEXT_FILE_LIMIT = 10000;
export const TURBO_PLAN_CODEBASE_CONTEXT_FILE_LIMIT = 20000;
export const AUTH_STATE_KEY = 'auth_state';
